import React from 'react'
import { FactorConversion } from '../../utils/conversions'

const unitConversionsContext = React.createContext<ReadonlyArray<FactorConversion>>([])

unitConversionsContext.displayName = 'UnitConversionsContext'

export { unitConversionsContext as UnitConversionsContext }
